import * as THREE from 'three'
window.THREE = THREE
require('@/vendor/OrbitControls.js')
// import '@/vendor/OrbitControls.js'
let MeshLine = require('three.meshline')

export { THREE, MeshLine }
